export default __webpack_public_path__ + "static/media/my-gifts-blue.4fa05250.svg";